import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callShopDrivingRangeOptionSetting = async (shopGuid) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/shop/${shopGuid}/driving-range-option-setting`));
};

export const callEditShopDrivingRangeOptionSetting = async (shopGuid, data) => {
    return await axiosInstance(requestConfig('put', URL_SYSTEM, `/shop/${shopGuid}/driving-range-option-setting`, data));
};